import { render, staticRenderFns } from "./FarmManager.vue?vue&type=template&id=d074ec2c&scoped=true&"
import script from "./FarmManager.vue?vue&type=script&lang=ts&"
export * from "./FarmManager.vue?vue&type=script&lang=ts&"
import style0 from "./FarmManager.vue?vue&type=style&index=0&id=d074ec2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d074ec2c",
  null
  
)

export default component.exports